module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"viewMoreImages":"+ {number} more pictures"},"de":{"viewMoreImages":"+ {number} weitere Bilder"}}')
  delete Component.options._Ctor
}
